export default __webpack_public_path__ + "static/macaron-ec794c5d07010427e50951d7a2914327.png";